<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-70 md-medium-size-100 px-0">
      <!-- GREETING -->
      <div class="md-layout-item">
        <greeting :info="info"></greeting>
      </div>
      <!-- GREETING -->

      <!-- ASSIGNED STUDENTS -->
      <div class="md-layout-item">
        <card-dashboard
          v-if="!studentList"
          :title="$t('dashboard.assigned_students', { length: 0 })"
        >
          <div class="flex justify-center">
            <no-data-found></no-data-found>
          </div>
        </card-dashboard>
        <card-dashboard
          v-else
          :title="
            $t('dashboard.assigned_students', { length: studentList.length })
          "
        >
          <div class="px-10 slick-slider-carousel">
            <VueSlickCarousel v-bind="settings">
              <div
                class="px-5"
                v-for="(item, index) in studentList"
                :key="item.username + index"
              >
                <card-carousel
                  :avatar="item.avatar_url || '/img/avt_placeholder.jpg'"
                  class="flex justify-center"
                >
                  <div class="w-full">
                    <p class="font-bold mb-2.5 truncate">
                      {{ $t("common.name") }}:
                      {{ item.full_name }}
                    </p>
                    <p class="text-sm font-normal mb-2.5 truncate">
                      {{ $t("common.student_code") }}:
                      {{ item.student_code }}
                    </p>
                    <p class="text-sm font-normal mb-2.5">
                      {{ $t("student.grade") }}: {{ item.grade }}
                    </p>
                  </div>
                </card-carousel>
              </div>
            </VueSlickCarousel>
          </div>
        </card-dashboard>
      </div>
      <!-- ASSIGNED STUDENTS -->
    </div>

    <div class="md-layout-item md-size-30 md-medium-size-100">
      <external-link></external-link>
      <!-- UPCOMING EVENTS -->
      <upcoming-events
        :path="path.upcomingEvents"
        :showTakeAttendance="false"
      ></upcoming-events>
      <!-- UPCOMING EVENTS -->
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import UpcomingEvents from "../Components/UpcomingEvents";
import CardDashboard from "../Components/CardDashboard";
import CardCarousel from "../Components/CardCarousel";
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";
import { service_paths } from "@/constants/Services";
import { SETTING_CAROUSEL } from "../Components/settings-carousel-config";
import { getId } from "@/helpers/utils";
import Greeting from "../Components/Gretting";
import NoDataFound from "../../../components/Base/Illustration/NoDataFound";
import ExternalLink from "../Components/ExternalLink";

export default {
  name: "dashboard-counselor",
  components: {
    ExternalLink,
    NoDataFound,
    Greeting,
    CardCarousel,
    CardDashboard,
    UpcomingEvents,
    VueSlickCarousel
  },
  data() {
    return {
      path: {
        upcomingEvents: `${service_paths.calendars}/dashboard?type=event`,
        assignedStudent: service_paths.users
      },
      settings: SETTING_CAROUSEL,
      studentList: null
    };
  },
  computed: {
    ...mapState("user", ["info"])
  },
  created() {
    this.fetchDataAssignedStudents();
  },
  methods: {
    fetchDataAssignedStudents() {
      this.$axios
        .get(
          `${this.path.assignedStudent}/${getId(this.info)}/assigned-students`
        )
        .then(({ data }) => {
          this.studentList = data.data.length ? data.data : false;
        });
    }
  }
};
</script>
